export default "__VITE_ASSET__3e426118__"